module.exports = __webpack_public_path__ + "img/videogames.af6bcf41.jpg";